import React from 'react';

import { MultiSelect } from '@metarouter-private/mr-mui';

import usePipelineTagMultiSelectProps from './usePipelineTagMultiSelectProps';

export default function PipelineTagMultiSelect() {
  const props = usePipelineTagMultiSelectProps();

  return <MultiSelect {...props} />;
}
